var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoLine = function SvgVideoLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.667 9.667 4.344-3.041a.417.417 0 0 1 .656.341v10.066a.417.417 0 0 1-.656.342l-4.344-3.041v3.5c0 .46-.373.833-.834.833H4.167a.833.833 0 0 1-.834-.834V6.168c0-.46.373-.833.834-.833h11.666c.46 0 .834.373.834.833zm0 2.632L20 14.632V9.368L16.667 11.7zM5 7v10h10V7z"
  })));
};
export default SvgVideoLine;